import React, { useEffect } from 'react';

/**
 * Global component that prevents number inputs from reacting to mouse scroll
 * This should be included at the top level of the app to work across all components
 */
const PreventNumberInputScroll: React.FC = () => {
  useEffect(() => {
    const handleWheel = (e: WheelEvent) => {
      const active = document.activeElement;
      if (
        active &&
        active.tagName === 'INPUT' &&
        (active as HTMLInputElement).type === 'number'
      ) {
        // Prevent the default scroll behavior on number inputs
        e.preventDefault();
        // Optionally blur the input to prevent any scroll interaction
        (active as HTMLInputElement).blur();
      }
    };

    // Add event listener with passive: false to allow preventDefault
    document.addEventListener('wheel', handleWheel, { passive: false });
    
    // Cleanup on unmount
    return () => {
      document.removeEventListener('wheel', handleWheel);
    };
  }, []);

  return null; // This component doesn't render anything
};

export default PreventNumberInputScroll; 